<app-toast [message]="toast.message"></app-toast>

<div class="row">
  <div class="col-2 ps-0 sidebar">
    <app-sidebar [items]="menuItems" [current]="currentContent"></app-sidebar>
  </div>
  <div class="col-10 px-0">
    @if (currentContent === 'login') {
      <div class="card">
        <h4 class="card-header">Login</h4>
        <div class="card-body">
          <app-login-form></app-login-form>
        </div>
      </div>
    }
    @if (currentContent === 'forgot-password') {
      <div class="card">
        <h4 class="card-header">Forgot password</h4>
        <div class="card-body">
          <app-forgot-password-form></app-forgot-password-form>
        </div>
      </div>
    }
  </div>
</div>